export function equalWithinTolerance(unit1: number, unit2: number, tolerance: number) {
  return Math.abs(unit1 - unit2) <= tolerance;
}
